/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import type { ContextRouter } from 'react-router-dom';
import { includes, without } from 'lodash';

import styles from './styles.module.scss';
import ToggleButton from '../../../components/ToggleButton';
import ActionButton from '../../../components/ActionButton';
import WorklistHeader from '../../../components/WorklistHeader';
import WorklistRow from '../../../components/WorklistRow';
import DataLoader from '../../../components/DataLoader';
import ScrollableContent from '../../../components/ScrollableContent';
import actions from '../../../redux/actions';
import { getWorklists } from '../../../redux/reducers/worklists';
import protonesUtils from '../../../utils/protones';

import type { ReduxState, Fetchable, Worklist } from '../../../types';

type Props = ContextRouter & {
  worklistList: Fetchable<Worklist[]>,
  createWorklist: typeof actions.createWorklist,
};

const mapStateToProps = (state: ReduxState, ownProps: Props) => {
  return {
    worklistList: getWorklists(state),
  };
};

type State = {
  selectedWorklistIds: number[],
};

class WorklistsIntro extends React.Component<Props, State> {
  state = {
    selectedWorklistIds: [],
  };

  _toggleWorklistSelection = (worklistId: number) => {
    const { selectedWorklistIds } = this.state;
    if (includes(selectedWorklistIds, worklistId)) {
      this.setState({ selectedWorklistIds: without(selectedWorklistIds, worklistId) });
    } else {
      this.setState({ selectedWorklistIds: [worklistId, ...selectedWorklistIds] });
    }
  };

  _toggleAllWorklistsSelection = () => {
    const {
      worklists: { data },
    } = this.props;
    const { selectedWorklistIds } = this.state;
    if (data) {
      const isSelectedAll = data.length !== 0 && selectedWorklistIds.length === data.length;
      if (isSelectedAll) {
        this.setState({ selectedWorklistIds: [] });
      } else {
        const allWorklistIds = data.map(item => item.id);
        this.setState({ selectedWorklistIds: allWorklistIds });
      }
    }
  };

  _handleCreateWorklist = () => {
    this.props.createWorklist();
    protonesUtils.goTo(this.props, protonesUtils.routes.worklists.create());
  };

  _handleWorklistClick = (id: number) => {
    protonesUtils.goTo(this.props, protonesUtils.routes.worklists.get(id));
  };

  // _handleEditWorklist = (id: number) => {
  //   this.props.fetchWorklist(id);
  //   protonesUtils.goTo(this.props, protonesUtils.routes.worklists.edit(id));
  // };

  _handlePublishWorklist = (worklist: Worklist) => {};

  _handleArchiveWorklist = (worklist: Worklist) => {};

  _handleDeleteWorklist = (id: number) => {
    //eslint-disable-next-line
    if (confirm(this.props.t('ARE_YOU_SURE'))) {
      this.props.deleteWorklist(id, () => {
        this.props.fetchWorklistList();
        protonesUtils.goTo(this.props, protonesUtils.routes.worklists.find());
      });
    }
  };

  _renderActionButtons = worklist => {
    const { t, updateWl1, updateWl2 } = this.props;
    return (
      <React.Fragment>
        <ToggleButton
          key={'worklist_1'}
          icon={'worklist_1'}
          tooltip={worklist.isWorklist1 ? t('SELECTED_AS_WL1') : t('SELECT_AS_WL1')}
          disabled={!worklist.isWorklist1}
          onClick={!worklist.isWorklist1 ? () => updateWl1(worklist.id) : undefined}
        />
        <ToggleButton
          key={'worklist_2'}
          icon={'worklist_2'}
          tooltip={worklist.isWorklist2 ? t('SELECTED_AS_WL2') : t('SELECT_AS_WL2')}
          disabled={!worklist.isWorklist2}
          onClick={!worklist.isWorklist2 ? () => updateWl2(worklist.id) : undefined}
        />
        {/* <IconButton icon={'edit'} tooltip={t('EDIT')} onClick={() => this._handleEditWorklist(worklist.id)} /> */}
        {/* <IconButton
          icon={'share'}
           tooltip={t('PUBLISH')}
          onClick={() => this._handlePublishWorklist(worklist)}
        />
        <IconButton
          icon={'archive'}
          tooltip={t('ARCHIVE')}
          onClick={() => this._handleArchiveWorklist(worklist)}
        /> */}
        <ActionButton
          iconName={'trash'}
          tooltip={t('DELETE')}
          onClick={() => this._handleDeleteWorklist(worklist.id)}
        />
      </React.Fragment>
    );
  };

  _renderWorklists = data => {
    const { selectedWorklistIds } = this.state;
    return (
      <div>
        {data.map(worklist => {
          const isSelected = includes(selectedWorklistIds, worklist.id);
          return (
            <WorklistRow
              key={worklist.id}
              isSelectable
              isSelected={isSelected}
              showCheckbox
              worklist={worklist}
              onCheckboxClick={() => this._toggleWorklistSelection(worklist.id)}
              onNameClick={() => this._handleWorklistClick(worklist.id)}
              onUsageClick={() => this._handleWorklistClick(worklist.id)}
              onItemsCountClick={() => this._handleWorklistClick(worklist.id)}
              onModifiedDateClick={() => this._handleWorklistClick(worklist.id)}
              actionButtons={this._renderActionButtons(worklist)}
            />
          );
        })}
      </div>
    );
  };

  render() {
    const {
      worklists: { data, fetching, error },
    } = this.props;
    const { selectedWorklistIds } = this.state;
    const isSelectedAll: boolean = data
      ? selectedWorklistIds.length === data.length && data.length > 0
      : false;
    return (
      <div className={styles.root}>
        <div className={styles.content}>
          <WorklistHeader
            isSelectable
            isSelected={isSelectedAll}
            onCheckboxClick={this._toggleAllWorklistsSelection}
            showCheckbox
          />
          <ScrollableContent>
            <DataLoader
              loading={fetching}
              error={error}
              data={data}
              render={this._renderWorklists}
            />
          </ScrollableContent>
        </div>
      </div>
    );
  }
}

export default withTranslation()(
  withRouter(
    connect(
      mapStateToProps,
      actions
    )(WorklistsIntro)
  )
);
